import { render, staticRenderFns } from "./CarStatus.vue?vue&type=template&id=1b4f7355&"
import script from "./CarStatus.vue?vue&type=script&lang=ts&"
export * from "./CarStatus.vue?vue&type=script&lang=ts&"
import style0 from "./CarStatus.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports